export const ToastOptions = (Type) => {

    if (Type === "success") {

        return {
            theme: "colored",
            className: "Toast"
        }
    } else if (Type === "error") {
        return {
            theme: "colored",
            className: "ToastError"
        }
    }
    else if (Type === "share") {
        return {
            theme: "colored",
            className: "ToastShare",
            position: "bottom-center", // This sets the toast position to center bottom
        };
    }
    else if (Type === "error_Link") {
        return {
            theme: "colored"
        };
    }
}